/** @file Dab centres every `spacing` along a pointer segment, continuing the stroke's running distance. */

/**
 * Centres (x, y pairs) along from → to, the first `spacing − carry` past `from` (`carry` = distance travelled since
 * the stroke's last dab), and the new carry. A spacing ≤ 0 puts one dab at `to`.
 */
export function strokeDabs(fx: number, fy: number, tx: number, ty: number, spacing: number, carry: number): { centres: number[]; carry: number } {
  if (!(spacing > 0)) return { centres: [tx, ty], carry: 0 };
  const len = Math.hypot(tx - fx, ty - fy);
  const centres: number[] = [];
  let next = spacing - carry;
  for (; next <= len; next += spacing) centres.push(fx + ((tx - fx) * next) / len, fy + ((ty - fy) * next) / len);
  return { centres, carry: len - (next - spacing) };
}
